import React from 'react';
import IconBirdLogo from 'components/icons/iconBirdLogo';
import IconPhone from 'components/icons/iconPhone';
import IconMail from 'components/icons/iconMail';
import IconSupportTextTwo from 'components/icons/iconSupportTextTwo';
import currentYear from 'commons/currentYear';
import useUserData from 'data-hooks/useUserData';

const CustomFooter = () => {
  const { isTradeUser } = useUserData();

  return (
    <footer className="flex flex-col justify-between items-center bg-white mt-8 p-8 [border-top:1px_solid_#f1f1f1] md:flex-row md:items-start lg:pl-16 min-[1440px]:pl-[13.5rem]">
      <ul className="flex p-0 max-w-full mt-0 mx-0 mb-[25px] md:mb-0 md:p-0">
        <li className="flex list-none m-0 p-0">
          <a
            href="tel:888-282-0842"
            className="mt-0 mr-4 mb-0 ml-0 text-center flex flex-col justify-between no-underline md:text-left md:block md:mt-0 md:mr-8 md:mb-0 md:ml-0 lg:mt-0 lg:mr-12 lg:mb-0 lg:ml-0"
          >
            <div className="lg:flex items-center">
              <div className="flex justify-center items-center min-h-[1.5rem] lg:min-h-[auto]">
                <IconPhone width={13} />
              </div>
              <div className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray leading-[1.75rem] block md:inline-block lg:ml-2">
                Call us
              </div>
            </div>

            {isTradeUser ? (
              <div className="text-sm text-gray hidden md:block [&_a]:text-gray [&_a]:font-normal [&_a]:no-underline">
                <a href="tel:+18552084414">855-208-4414</a>
              </div>
            ) : (
              <div className="text-sm text-gray hidden md:block [&_span]:text-gray [&_span]:font-normal [&_span]:no-underline">
                {/** Note: we don't want to wrap this phone number in an anchor tag here because there
                 * is already an anchor tag wrapping this entire div for accessibility purposes */}
                <span>888-282-0842</span>
              </div>
            )}
          </a>
        </li>

        <li className="flex list-none m-0 p-0">
          <a
            href={
              isTradeUser
                ? 'mailto:trade@joybird.com'
                : 'mailto:support@joybird.com'
            }
            className="mt-0 mr-4 mb-0 ml-0 text-center flex flex-col justify-between no-underline md:text-left md:block md:mt-0 md:mr-8 md:mb-0 md:ml-0 lg:mt-0 lg:mr-12 lg:mb-0 lg:ml-0"
          >
            <div className="lg:flex items-center">
              <div className="flex justify-center items-center min-h-[1.5rem] lg:min-h-[auto]">
                <IconMail width={16} />
              </div>
              <div className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray leading-[1.75rem] block md:inline-block lg:ml-2">
                Email us
              </div>
            </div>

            {isTradeUser ? (
              <div className="text-sm text-gray hidden md:block [&_span]:text-gray [&_span]:font-normal [&_span]:no-underline">
                <span>trade@joybird.com</span>
              </div>
            ) : (
              <div className="text-sm text-gray hidden md:block [&_span]:text-gray [&_span]:font-normal [&_span]:no-underline">
                <span>support@joybird.com</span>
              </div>
            )}
          </a>
        </li>

        {isTradeUser && (
          <li className="flex list-none m-0 p-0">
            <a
              href="mailto:support@joybird.com"
              className="mt-0 mr-4 mb-0 ml-0 text-center flex flex-col justify-between no-underline md:text-left md:block md:mt-0 md:mr-8 md:mb-0 md:ml-0 lg:mt-0 lg:mr-12 lg:mb-0 lg:ml-0"
            >
              <div className="lg:flex items-center">
                <div className="flex justify-center items-center min-h-[1.5rem] lg:min-h-[auto]">
                  <IconSupportTextTwo width={16} />
                </div>
                <div className="text-[.8125rem] tracking-[.0187rem] font-bold text-gray leading-[1.75rem] block md:inline-block lg:ml-2">
                  Text us
                </div>
              </div>

              <div className="text-sm text-gray hidden md:block [&_a]:text-gray [&_a]:font-normal [&_a]:no-underline">
                <a href="sms:+12139082099">213-908-2099</a>
              </div>
            </a>
          </li>
        )}
      </ul>

      <div className="flex items-center flex-row-reverse md:flex-row lg:mr-16 [&_svg]:hidden [&_svg]:md:block">
        <span className="text-sm text-gray ml-2 mr-4 flex flex-row items-center">
          &#169; {currentYear} Joybird, All rights reserved.
        </span>
        <IconBirdLogo width={40} height={29} color="#E1E1E0" />
      </div>
    </footer>
  );
};
export default CustomFooter;
